module.exports = __webpack_public_path__ + "img/WP2023-Floorplan-thumb.fcb0c725.png";